import config from '../../config';
import { SpriteToRect } from '../../utils';
import { getStepPos } from './tools';

const TILE_SIZE = config.TILE_SIZE;
const TILE_SIZE_HALF = TILE_SIZE / 2;
const HERO_SIZE = 50;
const UP = config.UP;
const DOWN = config.DOWN;
const LEFT = config.LEFT;
const RIGHT = config.RIGHT;

let soundManager;
let dataManager;

let prefix = 'bumblebee';
let suffix = 'hover';

let SCALE = 0.70;

class Player {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;

    soundManager = g.scene.get('SoundManager');
    dataManager = g.sys.game.dataManager;
    dataManager.setSessionItem('Bumps', 0);

    prefix = 'bumblebee';
    suffix = 'hover';

    this.glowSprite = g.add.sprite(0, 0, 'bumblebee-glow');

    this.sprite = g.add.sprite(0, 0, 'bumblebee');
    this.sprite.setScale(SCALE);

    this.trailSprite = g.add.sprite(0, 0, 'bumblebee-trail');
    // this.trailSprite.play('trail-reveal');
    this.trailSprite.setScale(SCALE);

    this.armorRecovery = false;

    this.inMotion = false;
    this.setPosition(g.levelManager.startX, g.levelManager.startY);
    this.startCameraFollow();
    this.move(config.UP);
  }
  startCameraFollow () {
    let g = this.g;
    g.cameras.main.startFollow(this.sprite, false, 0.1, 0.1);
  }
  stopCameraFollow () {
    let g = this.g;
    g.cameras.main.stopFollow();
  }
  move (direction, force) {
    if ((!this.inMotion || force) && this.active) {
      if (!force) {
        this.startPosition = { x: this.x, y: this.y };
      }
      this.calcMove(direction);
    }
  }
  stop () {
    let g = this.g;
    g.cameras.main.shake(250, 0.0025);
    this.inMotion = false;
    this.sprite.setScale(SCALE);
    suffix = 'hover';
    this.sprite.play(`${prefix}-${suffix}`);
  }
  calcAnimation (direction) {
    switch (direction) {
      case UP:
        this.sprite.setScale(SCALE);
        suffix = 'up';
        this.sprite.play(`${prefix}-${suffix}`);
        // this.trailSprite.setAngle(90);
        this.trailSprite.setAngle(270);
        this.trailSprite.setAlpha(1);
        this.trailSprite.play('trail-reveal');
        break;
      case DOWN:
        this.sprite.setScale(SCALE);
        suffix = 'down';
        this.sprite.play(`${prefix}-${suffix}`);
        // this.trailSprite.setAngle(270);
        this.trailSprite.setAngle(90);
        this.trailSprite.setAlpha(1);
        this.trailSprite.play('trail-reveal');
        break;
      case LEFT:
        this.sprite.setScale(-SCALE, SCALE);
        suffix = 'side';
        this.sprite.play(`${prefix}-${suffix}`);
        // this.trailSprite.setAngle(0);
        this.trailSprite.setAngle(180);
        this.trailSprite.setAlpha(1);
        this.trailSprite.play('trail-reveal');
        break;
      case RIGHT:
        this.sprite.setScale(SCALE);
        suffix = 'side';
        this.sprite.play(`${prefix}-${suffix}`);
        // this.trailSprite.setAngle(180);
        this.trailSprite.setAngle(0);
        this.trailSprite.setAlpha(1);
        this.trailSprite.play('trail-reveal');
        break;
    }
  }
  calcMove (direction) {
    // console.log('Player.move', direction);
    let g = this.g;
    let levelManager = g.levelManager;
    let rayCasting = true;
    let step = 0;
    let tileResult = null;
    let stepPos = null;

    while (rayCasting) {
      step++;
      stepPos = getStepPos(direction, this.x, this.y, step);
      tileResult = levelManager.checkAllTiles(stepPos);
      if (tileResult) {
        rayCasting = false;
      }
    }

    switch (tileResult.layerName) {
      case config.ELECTRIC_GATE:
      case config.ZAPPER_WALLS:
      case config.WALL:
      case config.GATE:
      case config.GATE_BLOCKS:
        step--;
        break;
      case config.EXIT:
        step++;
        break;
    }

    if (step < 1) { return; }
    soundManager.playSound('move-swoosh');
    this.inMotion = direction;
    this.calcAnimation(direction);
    stepPos = getStepPos(direction, this.x, this.y, step);
    this.tween = g.tweens.add({
      targets: this.sprite,
      x: stepPos.x,
      y: stepPos.y,
      duration: config.STEP_SPEED * step,
      // ease: 'Sine.easeOut',
      onComplete: this.onTweenComplete.bind(this, tileResult)
    });
  }
  onTweenComplete (tile) {
    let g = this.g;
    this.trailSprite.setAlpha(0);
    g.levelManager.closeGate();
    switch (tile.layerName) {
      case config.EXIT:
        this.exit();
        break;
      case config.BUMPER:
        this.bump(tile);
        break;
      case config.WARPS:
        this.warp(tile);
        break;
      case config.SPIKES:
        this.takeHit(config.SPIKES);
        break;
      case config.ELECTRIC_GATE:
      case config.ZAPPER_WALLS:
      case config.WALL:
      case config.GATE:
      case config.GATE_BLOCKS:
        // this.inMotion = false;
        this.stop();
        break;
      default:
        console.warn('No logic for tile layer', tile.layerName);
        // this.inMotion = false;
        this.stop();
    }
    // console.log('Player.onTweenComplete', _.clone(g.levelManager.scroll));
  }
  exit () {
    let g = this.g;
    this.stopCameraFollow();
    g.levelManager.transition();
    this.bringToTop();
    g.bringFgToTop();
    // g.children.bringToTop(g.fg);
    this.tween = g.tweens.add({
      targets: this.sprite,
      y: '+=' + config.HEIGHT,
      duration: config.TRANSITION_DURATION,
      ease: 'Sine.easeOut',
      onComplete: () => {
        g.levelManager.onTransitionComplete();
        this.setPosition(g.levelManager.startX, g.levelManager.startY);
        this.startCameraFollow();
        this.inMotion = false;
        this.move(config.UP);
      }
    });
  }
  bringToTop () {
    let g = this.g;
    g.children.bringToTop(this.glowSprite);
    g.children.bringToTop(this.sprite);
    g.children.bringToTop(this.trailSprite);
  }
  warp (tile) {
    let g = this.g;
    // this.setPosition(tile.warpTo.x, tile.warpTo.y);
    soundManager.playSound('portal-enter');
    tile.highlight.play('warp-enter-exit');
    this.sprite.setVisible(false);
    this.glowSprite.setVisible(false);
    this.trailSprite.setVisible(false);
    this.tween = g.tweens.add({
      targets: this.sprite,
      x: tile.warpTo.x,
      y: tile.warpTo.y,
      duration: 100,
      onComplete: () => {
        soundManager.playSound('portal-exit');
        tile.warpTo.highlight.play('warp-enter-exit');
        this.sprite.setVisible(true);
        this.glowSprite.setVisible(true);
        this.trailSprite.setVisible(true);
        this.move(tile.warpTo.direction, true);
      }
    });
  }
  bump (sprite) {
    sprite.play('bump');
    soundManager.playSound('bumper');
    let bumps = dataManager.getSessionItem('Bumps');
    bumps++;
    dataManager.setSessionItem('Bumps', bumps);
    switch (this.inMotion) {
      case config.LEFT:
      case config.RIGHT:
        this.move(sprite.bump[0], true);
        break;
      case config.UP:
      case config.DOWN:
        this.move(sprite.bump[1], true);
        break;
    }
  }
  takeHit (hitType) {
    let g = this.g;

    if (g.activePowerUp !== config.ARMOR) {
      this.explode();
      return false;
    }

    this.armorRecovery = true;
    g.startCoolDown();
    let burst = g.add.sprite(this.x, this.y, 'armor-burst');
    burst.play('armor-burst');
    burst.once('animationcomplete', () => {
      burst.destroy();
    });
    g.burstArmor();
    soundManager.playSound('armor-destroyed');

    if (this.inMotion) {
      this.tween.stop();
      this.trailSprite.setAlpha(0);
      this.setPosition(this.startPosition.x, this.startPosition.y);
      g.time.delayedCall(500, () => {
        this.inMotion = false;
      });
    } else if (
      hitType === config.EXPANDERS ||
      hitType === config.ZAPPER_WALLS ||
      hitType === config.ELECTRIC_GATE
    ) {
      this.setPosition(this.startPosition.x, this.startPosition.y);
    }
    prefix = 'bumblebee';
    suffix = 'hover';
    this.sprite.play(`${prefix}-${suffix}`);
    g.cameras.main.shake(1000, 0.01);

    g.tweens.add({
      targets: this.sprite,
      alpha: 0,
      repeat: 10,
      duration: 100,
      repeatDelay: 100,
      onComplete: () => {
        this.armorRecovery = false;
        this.sprite.setAlpha(1);
      }
    });

    return true;
  }
  explode () {
    let g = this.g;
    this.tween.stop();
    // this.sprite.setAlpha(0);
    this.glowSprite.setVisible(false);
    this.glowSprite.setActive(false);
    this.sprite.setVisible(false);
    this.sprite.setActive(false);
    this.trailSprite.setVisible(false);
    this.trailSprite.setActive(false);
    let cakeParticles = g.add.particles('cake-particles');
    let cakeParticleEmitter = cakeParticles.createEmitter({
      x: this.sprite.x,
      y: this.sprite.y,
      speed: { min: 100, max: 300 },
      lifespan: 3000,
      on: false
    });
    let frames = [];
    for (let i = 0; i < 7; i++) {
      let frameIndex = i + 1;
      frames.push(`particle-${frameIndex}.png`);
    }
    cakeParticleEmitter.setFrame(frames);
    cakeParticleEmitter.explode(30);
    g.cameras.main.shake(500, 0.005);
    soundManager.playSound('gameover-splat');

    let bb = g.add.sprite(this.x, this.y, 'bumblebee');
    // bb.setScale(0.5);
    bb.play('bumblebee-death');

    let timeline = g.tweens.createTimeline();
    timeline.add({
      targets: bb,
      y: '-=' + 200,
      duration: 500,
      ease: 'Quad.easeOut'
    });
    timeline.add({
      targets: bb,
      y: '+=' + config.HEIGHT,
      duration: 1000,
      ease: 'Quad.easeIn',
      onComplete: () => {
        g.showContinue();
      }
    });

    timeline.play();
  }
  turnOnMagnet () {
    let g = this.g;
    this.glowSprite.setScale(0);
    this.glowSprite.setTexture('magnet-animation');
    this.glowSprite.setAlpha(0);
    this.glowSprite.setScale(1);
    this.glowSprite.play('magnet-animation');
    g.tweens.add({
      targets: this.glowSprite,
      alpha: 0.5,
      scaleX: 2,
      scaleY: 2,
      duration: 300
    });
  }
  turnOffMagnet () {
    let g = this.g;
    this.glowSprite.anims.stop();
    this.glowSprite.setTexture('bumblebee-glow');
    this.glowSprite.setAlpha(1);
    this.glowSprite.setScale(1);
  }
  turnOnArmor () {
    let g = this.g;
    prefix = 'armor-bumblebee';
    this.sprite.play(`${prefix}-${suffix}`);
    let burst = g.add.sprite(this.x, this.y, 'armor-burst');
    burst.play('armor-burst');
    burst.once('animationcomplete', () => {
      burst.destroy();
    });
  }
  setPosition (x, y) {
    this.x = x;
    this.y = y;
  }
  update () {
    this.glowSprite.setPosition(this.sprite.x, this.sprite.y);
    this.trailSprite.setPosition(this.sprite.x, this.sprite.y);
  }
  get x () {
    return this.sprite.x;
  }
  get y () {
    return this.sprite.y;
  }
  get width () {
    return config.HERO_SIZE;
  }
  get height () {
    return config.HERO_SIZE;
  }
  get active () {
    return this.sprite.active;
  }
  get visible () {
    return this.sprite.visible;
  }
  set x (x) {
    this.sprite.x = x;
  }
  set y (y) {
    this.sprite.y = y;
  }
  set active (bool) {
    this.sprite.setActive(bool);
  }
}

export default Player;
